/**
 * Stable identifiers for the two separate candidate inquiry / leads grid surfaces.
 * Do not reuse one id across both: saved column order, visibility, or filter payloads must stay isolated.
 */

/** Candidate Engagement workspace route — inquiries grid (server-filtered, tabbed). */
export const CANDIDATE_ENGAGEMENT_INQUIRIES_GRID_TAG = 'candidate-engagement-inquiries';

/** Persisted “My Views” / Save As filter sets for Candidate Engagement (isolated from grid column prefs). */
export const CANDIDATE_ENGAGEMENT_INQUIRIES_FILTER_VIEWS_PREFERENCE_ID = 'candidate-engagement-inquiries-filter-views';

/** Field on user grid preference `value` for last-applied lead/inquiry filters (Cosmos / shared prefs API). */
export const CURRENT_LEADS_FILTER_SNAPSHOT_PREF_KEY = 'currentFilterSnapshot';

/**
 * Candidate profile → Leads tab grid. Scoped by traveler so persisted layout stays per-candidate when needed.
 */
export function getCandidateProfileLeadsGridTag(travelerId: string | number): string {
  const id = String(travelerId).trim();
  return id ? `candidate-profile-leads-${id}` : 'candidate-profile-leads';
}
